import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('g', { id: 'Artboard-32' }),
  React.createElement('g', { id: 'Artboard-32-2', 'data-name': 'Artboard-32' }),
  React.createElement('path', { d: 'M27.63,7.12H21.74V5.54a.65.65,0,1,0-1.3,0V7.12H11.56V5.54a.65.65,0,1,0-1.3,0V7.12H4.37A2.65,2.65,0,0,0,1.72,9.77V24.46a2.65,2.65,0,0,0,2.65,2.65H27.63a2.65,2.65,0,0,0,2.65-2.65V9.77A2.65,2.65,0,0,0,27.63,7.12ZM29,24.46a1.35,1.35,0,0,1-1.35,1.35H4.37A1.35,1.35,0,0,1,3,24.46V9.77A1.34,1.34,0,0,1,4.37,8.43h5.89V9.57a.65.65,0,0,0,1.3,0V8.43h8.88V9.57a.65.65,0,1,0,1.3,0V8.43h5.89A1.34,1.34,0,0,1,29,9.77Z' }),
  React.createElement('path', { d: 'M25.55,11.7H18.3V13h6.6v8.23H16.63V12.35A.65.65,0,0,0,16,11.7H6.45a.65.65,0,0,0-.65.65v9.53a.65.65,0,0,0,.65.65h7v-1.3H7.1V13h8.23v8.88a.65.65,0,0,0,.65.65h9.57a.65.65,0,0,0,.65-.65V12.35A.65.65,0,0,0,25.55,11.7Z' }),
  React.createElement('path', { d: 'M9.29,16.5v1.22a1.88,1.88,0,1,0,3.76,0V16.5a1.88,1.88,0,1,0-3.76,0Zm2.79,0v1.22a.92.92,0,1,1-1.82,0V16.5a.92.92,0,1,1,1.82,0Z' }),
  React.createElement('path', { d: 'M21.35,14.59,18.74,17.7v.79h2.51v1.15h1V18.49h.66v-.9h-.66v-3Zm-.1,3H19.94L21.25,16Z' })
));